import { TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE } from '../shared/abstract-boxes';

export const ALWAYS_LAST_ANSWER_TYPES = ['user-input', 'next-box-by-default'];


export function QuestionBoxViewConstructor(services, callbacks, context, siteTypeConfig) {

  const DEFAULT_BOX_WIDTH = 250;

  let joint = services.joint;
  let companyId = context.companyId;
  let site = context.site;
  let scenarioId = context.scenarioId;
  let showTextComposer = true;
  let showMediaContent = true;

  return joint.shapes.html.AbstractBoxElementWithDragAndDropView.extend({

    template:
      `<div class="html-element">
        <div class="question-media-content" ng-style="visibility: ${showMediaContent ? 'visible' : 'hidden'}">
          <img src="" width="100%">
          <video preload="" controls="" src="" width="100%" style="pointer-events: auto;"></video>
          <div class="question-file-attachment">
            <span class="glyphicon glyphicon-file"></span>
            <span class="question-file-name"></span>
          </div>
        </div>
        <div class="question-text-content-container"  ng-style="visibility: ${showTextComposer ? 'visible' : 'hidden'}">
          <div class="question-text-content"></div>
          <div class="question-edit-container"><span class="glyphicon glyphicon-pencil question-edit"></span></div>
        </div>
        <div class="error-messages-container">
          <div class="all-descriptions-or-none-message invalid-message ng-hide">
            ${services.$translate.instant('parameters/quick_replies/internal_errors/3')}
          </div>
        </div>
        <button class="add-answer center-block btn btn-alcmeon-default">
          ${services.$translate.instant('parameters/quick_replies/details/add_an_answer')}
        </button>
      </div>`,


    initialize: function () {

      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);
      // this.$box is initialized by the abstract superclass
      this.$box.find('.add-answer').on('click', () => this.addAnswer());
      this.$box.find('.question-edit').on('click', function (evt) {
        // Question content is required but root question content is not, so we need to known which type it is
        this.editQuestion(this.model.get('type'));
      }.bind(this));
      this.setQuestionHtmlContent();

      this.updateBox();
    },

    _updatePreview: function () {
      const isWhatsappAccount = services.WhatsappFactory.getType() === site.type;
      const mediaMessageType = this.model.get('pictureId') || this.model.get('videoId');

      showTextComposer = !isWhatsappAccount || !mediaMessageType;
      showMediaContent = !isWhatsappAccount || mediaMessageType;
    },

    editQuestion: function (elementType) {
      function resultAction(result) {
        if (result.type === 'edit') {
          this.model.set('content', result.data.content);
          this.model.set('links', result.data.links);
          this.model.set('pictureId', result.data.pictureId);
          this.model.set('videoId', result.data.videoId);
          this.model.set('fileId', result.data.fileId);
          this.model.set('fileName', result.data.fileName);
          this.model.set('menuChoice', result.data.menuChoice);
          this.model.set('spellCheckerLang', result.data.spellCheckerLang);
          this.model.set('disableInput', result.data.disableInput);
          this.model.set('summaryText', result.data.summaryText);
        }
        this.setQuestionHtmlContent();
        callbacks.updateSerializedGraph(this.model.graph);

        //Reorder and resize needed for both editing and deleting
        this.reorderChildren();
        this.resizeQuestionBox();
      }

      let modalInstance = services.$uibModal.open({
        animation: true,
        template: require('./editQuestion.modal.html'),
        controller: 'editQuestionController',
        resolve: {
          type: () => this.model.get('type'),
          content: () => this.model.get('content'),
          links: () => this.model.get('links'),
          pictureId: () => this.model.get('pictureId'),
          videoId: () => this.model.get('videoId'),
          fileId: () => this.model.get('fileId'),
          fileName: () => this.model.get('fileName'),
          menuChoice: () => this.model.get('menuChoice'),
          spellCheckerLang: () => this.model.get('spellCheckerLang'),
          disableInput: () => this.model.get('disableInput'),
          isRoot: () => elementType === 'html.RootQuestionBox',
          quickRepliesElementsConfig: () => siteTypeConfig,
          isMessageWithChoice: () => elementType === 'html.MessageWithChoiceBox',
          isQuestionBox: () => elementType === 'html.QuestionBox',
          summaryText: () => this.model.get('summaryText'),
          companyId: companyId,
          site: site
        }
      });
      modalInstance.result.then(resultAction.bind(this));
    },

    setQuestionHtmlContent: function () {
      this._updatePreview();

      this.$box.find('.question-text-content').text(this.model.get('content'));

      const pictureId = this.model.get('pictureId');
      this.$box.find('img').css('display', pictureId ? 'initial' : 'none');
      if (pictureId) {
        services.MediasFactory.pictureUrlWithJWT(companyId, pictureId).then((urlWithJwt) => {
          this.$box.find('img').attr('src', urlWithJwt);
          this.$box.find('img').load(() => {
            if (!services.JointjsOptimisationsFactory.isDeserializingInProgress()) {
              this.resizeQuestionBox();
            }
          });
        });
      }

      const videoId = this.model.get('videoId');
      this.$box.find('video').css('display', videoId ? 'initial' : 'none');
      if (videoId) {
        services.MediasFactory.videoUrlWithJWT(companyId, videoId).then((urlWithJwt) => {
          this.$box.find('video').attr('src', urlWithJwt);
          this.$box.find('video').load(() => {
            if (!services.JointjsOptimisationsFactory.isDeserializingInProgress()) {
              this.resizeQuestionBox();
            }
          });
        });
      }

      const fileId = this.model.get('fileId');
      this.$box.find('.question-file-attachment').css('display', fileId ? 'block' : 'none');
      this.$box.find('.question-file-name').text(this.model.get('fileName'));

    },

    resizeBox: function resizeBox() {
      this.resizeQuestionBox();
    },


    resizeQuestionBox: function resizeQuestionBox() {
      if (services.JointjsOptimisationsFactory.logCallsToResize()) {
        console.warn('QuestionBoxView - resizeQuestionBox()');
      }
      const question = this.model;
      const embeddedCells = question.getEmbeddedCells();

      const $addAnswer = this.$box.find('.add-answer');

      const paddingBottom = $addAnswer.outerHeight();
      const paddingTop = this.paddingTop();

      //Reposition and resize every answer
      let ypos = paddingTop;
      for (let answerOrNext of embeddedCells) {
        const answerOrNextView = this.paper.findViewByModel(answerOrNext);
        answerOrNext.position(0, ypos, { parentRelative: true });

        const answerOrNextHeight = answerOrNextView.$box.outerHeight();
        answerOrNext.resize(question.attributes.size.width, answerOrNextHeight);
        ypos += answerOrNextHeight;
      }

      //resize question
      if (embeddedCells.length === 0) {
        question.resize(DEFAULT_BOX_WIDTH, paddingTop + paddingBottom);
      } else {
        question.fitEmbeds({ padding: { top: paddingTop, right: 0, bottom: paddingBottom, left: 0 } });
      }

      //resize paper height if necessary
      callbacks.resizePaper();
    },


    /** 
     * On twitter, either all text answers or no text answer must have a description.
     * Caller is responsible to call resizeQuestionBox, if necessary
     */
    updateValidity: function () {
      let allHaveDescription = true;
      let noneHaveDescription = true;
      this.model.getEmbeddedCells()
        .filter(answer => answer.attributes.answerType === 'simple-text')
        .map(simpleTextAnswer => simpleTextAnswer.get('description'))
        .forEach(description => {
          if (description && description.trim() !== '') {
            noneHaveDescription = false; // just found one that does have a description
          } else {
            allHaveDescription = false; // just found one that doesn't have a description
          }
        });
      const valid = !siteTypeConfig.hasDescription || noneHaveDescription || allHaveDescription;
      this.model.setBoxValid(valid);
      if (valid) {
        this.$box.find('.all-descriptions-or-none-message').addClass('ng-hide');
      } else {
        this.$box.find('.all-descriptions-or-none-message').removeClass('ng-hide');
      }
    },

    getChosenAnswerTypes: function getChosenAnswerTypes() {
      let chosenAnswerTypes = {};

      let question = this.model;
      let answers = question.getEmbeddedCells();
      for (let answer of answers) {
        chosenAnswerTypes[answer.attributes.answerType] = true;
      }
      return chosenAnswerTypes;
    },

    getSpecialInputAnswerId: function getSpecialInputAnswerId(inputTypeName) {
      // Loop on all answers and look if one is of "inputTypeName" type
      let question = this.model;
      let answers = question.getEmbeddedCells();
      for (let answer of answers) {
        if (answer.attributes.answerType === inputTypeName) {
          return answer.attributes.id;
        }
      }
      return 0;
    },

    saveSpecialInputId: function saveSpecialInputId(inputTypeName, inputGraphName) {
      let special_input_answer_id = this.getSpecialInputAnswerId(inputTypeName);
      if (special_input_answer_id != 0) {
        this.model.set(inputGraphName, special_input_answer_id);
      }
      else {
        this.model.set(inputGraphName, undefined);
      }
    },

    saveSpecialInputsIds: function saveSpecialInputsIds() {
      this.saveSpecialInputId('user-input', 'user_input_answer_id');
      this.saveSpecialInputId('phone-number', 'phone_number_answer_id');
      this.saveSpecialInputId('email', 'email_answer_id');
    },

    removeSpecialInputsId: function removeSpecialInputsId(inputTypeName) {
      var inputGraphName = null;
      switch (inputTypeName) {
        case 'user-input':
          inputGraphName = 'user_input_answer_id';
          break;
        case 'phone-number':
          inputGraphName = 'phone_number_answer_id';
          break;
        case 'email':
          inputGraphName = 'email_answer_id';
          break;
        default:
          break;
      }
      if (inputGraphName) {
        this.model.set(inputGraphName, undefined);
      };
    },

    assignNumbersToAnswers: function () {
      let question = this.model;
      let answers = question.getEmbeddedCells();
      for (let answer of answers) {
        // Update answers numbers on delete or when menuChoice changes

        if (question.get('type') === 'html.MessageWithChoiceBox'
          && answer.get('answerType') !== 'next-box-by-default') {
          if (question.get('menuChoice') === 1) {
            answer.set('order', answers.indexOf(answer) + 1)  // 1,2,3
          } else {
            answer.set('order', String.fromCharCode('A'.charCodeAt(0) + answers.indexOf(answer)));  // A,B,C
          }
        }
      }
    },


    //Create an answer element with given id
    createAnswer: function (id,
      position = TMP_ELEMENT_POSITION,
      size = TMP_ELEMENT_SIZE,
      label = 'Answer',
      description = '',
      answerType,
      hasHandover = false,
      hasVerbatimMode = false,
      pictureId, // TODO remove after gouvfr scenarios are migrated
      pictureDataURL,
      order = null,
      inputListVariable,
      templateJinjaVariable,
      selectedButtonIndexVariable,
      UrlButtonUrl,
      UrlButtonUrlAndroid,
      UrlButtonUrlIos,
      UrlButtonName,
      editable = true) {

      if (!answerType) {
        const maxButtons = (this.model.get('type') === 'html.QuestionBox' && siteTypeConfig.questionBox?.maxAnswers) || siteTypeConfig.maxAnswerNb;
        if ((maxButtons && this.numberOfButtons >= maxButtons) || this.model.get('maxNumberOfButtonsAllowed')) {
          answerType = 'default-answer';
          label = 'Default';
        } else {
          answerType = 'simple-text'
        }
      }

      let answer = new joint.shapes.html.Answer({
        label: label,
        description: description,
        id: id,
        position: position,
        size: size,
        answerType: answerType,
        hasHandover: hasHandover,
        hasVerbatimMode: hasVerbatimMode,
        pictureId: pictureId,
        pictureDataURL: pictureDataURL,
        order: order,
        notEditable: !editable,
        inputListVariable: inputListVariable,
        templateJinjaVariable: templateJinjaVariable,
        selectedButtonIndexVariable: selectedButtonIndexVariable,
        UrlButtonUrl: UrlButtonUrl,
        UrlButtonUrlAndroid: UrlButtonUrlAndroid,
        UrlButtonUrlIos: UrlButtonUrlIos,
        UrlButtonName: UrlButtonName
      });

      this.model.embed(answer);

      return answer;

      // caller is responsible for calling addCell(answer), this.reorderChildren(), this.resizeQuestionBox(),
      // and this.updateValidity(), if and when necessary
    },

    //Add a new answer with a new id; called on a add button click.
    addAnswer: function (label, answerType, editable) {
      const buttonAnswers = this.model.getEmbeddedCells().filter(child => child && child.get('answerType') !== 'user-input');
      const canAddButton =
        buttonAnswers.length < (this.model.get('type') === 'html.QuestionBox' && siteTypeConfig.questionBox?.maxAnswers ?
          siteTypeConfig.questionBox.maxAnswers :
          siteTypeConfig.maxAnswerNb);
      if (!canAddButton) {
        // We can not add more buttons, if the user click again then it will create a user input step.
        const hasNotUserInput = this.model.get('type') === 'html.QuestionBox' && !this.model.getEmbeddedCells().some(child => child && child.get('answerType') === 'user-input')
        if (hasNotUserInput) {
          services.QuickRepliesFactory.createUniqueId(companyId, site.id, scenarioId)
            .then(response => {
              let answer = this.createAnswer(response.data.id, undefined, undefined, label, undefined, 'user-input', undefined, undefined, undefined, undefined, undefined, editable, undefined, undefined);
              this.model.graph.addCell(answer);
              this.updateValidity();
              this.reorderChildren();
              this.resizeQuestionBox();
            },
              services.AlertingFactory.httpErrorHandler());
        }
      } else {
        services.QuickRepliesFactory.createUniqueId(companyId, site.id, scenarioId)
          .then(response => {
            let answer = this.createAnswer(response.data.id, undefined, undefined, label, undefined, answerType, undefined, undefined, undefined, undefined, undefined, editable, undefined, undefined);
            this.model.graph.addCell(answer);
            this.updateValidity();
            this.reorderChildren();
            this.resizeQuestionBox();
            if (['simple-text', 'url', 'app-link'].includes(answer.get('answerType'))) {
              this.numberOfButtons++;
            }
          },
            services.AlertingFactory.httpErrorHandler());
      }
    },

    getConfigurationOption: function () {
      return siteTypeConfig?.questionBox || null
    },

    /**
     * Overrides superclass
     * Returns the answer content's height, including image and/or error message
     */
    paddingTop: function () {
      const $questionContent = this.$box.find('.question-text-content');
      const $questionMedia = this.$box.find('.question-media-content');
      const $errorMessages = this.$box.find('.error-messages-container');
      return $questionContent.outerHeight() + $questionMedia.outerHeight() + $errorMessages.outerHeight();
    },

    /**
     * Overrides superclass
     * For QuestionBoxes, a couple of answer type must always be the last answer
     */
    isChildAlwaysLast: function (child) {
      return ALWAYS_LAST_ANSWER_TYPES.includes(child.get('answerType'));
    },

    /**
     * Overrides superclass
     * if we are a question with choice,
     * reassigns a number (or a letter, if the numbering scheme is set to letters) to each answer,
     */
    afterReorderChildren: function () {
      this.assignNumbersToAnswers();
    },


  });
}
